module.exports = __webpack_public_path__ + "img/sketch-prototype.13f5ff09.png";